export default {
  baseUrl: window["VUE_APP_API_URL"],
  loginEndpoint: '/api/merchant/login',
  refreshTokenEndpoint: '/api/merchant/auth/refresh',
  authorizationKey: window["VUE_APP_AUTHORIZE_KEY"] ? window["VUE_APP_AUTHORIZE_KEY"] : '1234567890',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: '',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  storageUserDataKeyName: 'userData',

}
